import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class PanoramicQueryServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 企业主体信息
  // 分页查询企业列表
  public getInfoList(opts: object) {
    const url = serverUrl + '/api/yunnan/company/page';
    return this.rSerivce.serverObj.post(url, opts);
  }
  /*  ↑ 企业主体信息 ↑  */

  // 删除危险源数据
  public deleteAccident(id: any) {
    const url = serverUrl + '/api/yunnan/company/delete?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  // 新增/修改企业信息数据
  public addOrEditInfoConfig(opts: object) {
    const url = serverUrl + '/api/yunnan/company/saveData';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 通过主键查询单条数据详情
  public getSinglePerformanceData(opts: object) {
    const url = serverUrl + '/api/yunnan/company/detail';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 危险源
  // 分页查询企业列表
  public getDangerSourceList(opts: object) {
    const url = serverUrl + '/api/yunnan/dangerSource/page';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 危化品工艺
  // 分页查询企业列表
  public getDangerousCraftList(opts: object) {
    const url = serverUrl + '/api/yunnan/dangerousCraft/page';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 危险化学品
  // 分页查询企业列表
  public getDangerousChemicalsList(opts: object) {
    const url = serverUrl + '/api/yunnan/dangerousChemicals/page';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 企业信息
  public getEntDataList() {
    const url = serverUrl + '/api/yunnan/company/richSelect';
    return this.rSerivce.serverObj.get(url, {
      params: { searchValue: '' },
    });
  }
}
